/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Addon_Reviewer_HintInputs */

const en_billing_addon_reviewer_hint = /** @type {(inputs: Billing_Addon_Reviewer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Used after your plan's monthly Pemeriksa quota; never expires.`)
};

const id_billing_addon_reviewer_hint = /** @type {(inputs: Billing_Addon_Reviewer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipakai setelah jatah Pemeriksa bulanan paket habis; tidak kedaluwarsa.`)
};

/**
* | output |
* | --- |
* | "Used after your plan's monthly Pemeriksa quota; never expires." |
*
* @param {Billing_Addon_Reviewer_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const billing_addon_reviewer_hint = /** @type {((inputs?: Billing_Addon_Reviewer_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Addon_Reviewer_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_billing_addon_reviewer_hint(inputs)
	return en_billing_addon_reviewer_hint(inputs)
});